<template>
  <div
    class="m-button"
    :class="{
      'm-dark-button': dark
    }"
    @click="$emit('click')"
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    dark: Boolean
  }
}
</script>

<style scoped>
.m-button { cursor: pointer; position: relative; -webkit-transition: background-color .3s; -moz-transition: background-color .3s; -o-transition: background-color .3s; transition: background-color .3s; }
.m-button:hover { background: rgba(255, 255, 255, .15); }
.m-dark-button:hover { background: rgba(0, 0, 0, .15); }
</style>



// WEBPACK FOOTER //
// src/components/buttons/MButton.vue